<template>
  <main class="faq-page">
    <b-container class="py-5">
      <header class="text-center mx-auto mb-5">
        <p class="eyebrow">HELP CENTER</p>
        <h1>CashBoomerang Frequently Asked Questions</h1>
        <p class="lead text-muted">Clear answers about eligible offers, tracking, pending rewards, affiliate links, and payouts.</p>
        <p class="small text-muted">Reviewed July 26, 2026</p>
      </header>

      <section class="faq-list mx-auto">
        <article v-for="item in questions" :key="item.question" class="faq-item">
          <h2>{{ item.question }}</h2>
          <p>{{ item.answer }}</p>
        </article>
      </section>

      <section class="help-card mx-auto text-center">
        <h2>Start with the basics</h2>
        <p>Our step-by-step explanation covers the full path from offer activation to an available reward.</p>
        <router-link to="/how-cashback-works" class="btn btn-success">How cash back works</router-link>
      </section>
    </b-container>
  </main>
</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
      questions: [
        { question: 'Is every product on CashBoomerang eligible for cash back?', answer: 'No. Only offers explicitly marked Cash Back Eligible can earn a reward. Other product links may be disclosed affiliate shopping links without user cash back.' },
        { question: 'Do Amazon purchases earn CashBoomerang cash back?', answer: 'No. Amazon Associates links may generate a commission for CashBoomerang, but Amazon program rules do not permit us to offer users money, rebates, points, or other incentives for using those links.' },
        { question: 'Why is my reward pending?', answer: 'The retailer must validate the purchase and wait for cancellation or return risks to pass. Approval timing varies by retailer and purchase type.' },
        { question: 'Why might a purchase be missing?', answer: 'Common causes include shopping before activation, ad blockers, competing extensions, an existing cart, unapproved coupon codes, excluded products, or completing the order in a different browser or device.' },
        { question: 'Can a reward be reversed?', answer: 'Yes. Returns, cancellations, partial refunds, duplicate orders, excluded products, or retailer rejection can reverse some or all of a pending or approved reward.' },
        { question: 'How is the cash-back amount calculated?', answer: 'The offer terms specify whether the reward is a percentage or a fixed amount. Percentages normally apply to the eligible subtotal before taxes, shipping, fees, and excluded items.' },
        { question: 'When can I request a payout?', answer: 'Payouts can be requested only from available rewards after the account reaches the threshold displayed in the dashboard. Pending rewards do not count toward that threshold.' },
        { question: 'Does CashBoomerang sell the products shown on the site?', answer: 'No. Purchases, delivery, returns, warranties, and customer service are handled by the third-party retailer. CashBoomerang provides shopping information and eligible referral links.' }
      ]
    }
  }
}
</script>

<style scoped>
.faq-page { background: #f7faf7; color: #24342a; min-height: 75vh; }
header { max-width: 780px; }
header h1 { font-size: clamp(2rem, 5vw, 3.2rem); font-weight: 700; }
.eyebrow { color: #198754; font-weight: 700; letter-spacing: .14em; }
.faq-list, .help-card { max-width: 820px; }
.faq-item { background: #fff; border: 1px solid #dfeae2; border-radius: 16px; padding: 24px 28px; margin-bottom: 16px; }
.faq-item h2 { font-size: 1.2rem; font-weight: 700; }
.faq-item p { line-height: 1.75; margin: 0; color: #536258; }
.help-card { background: #eaf6ed; border-radius: 18px; padding: 32px; margin-top: 48px; }
</style>

